import {
  Button,
  Input,
  List,
  ListItemButton,
  ListItemContent,
  ListItemDecorator,
  Typography,
} from "@mui/joy";
import { Box, Popover } from "@mui/material";
import { ReactNode, useState } from "react";
import { useLibrarianPieces } from "../../redux/librarianPiece/librarianPieceHooks";
import { LibrarianPiece } from "../../entities/librarianPiece";

/**
 *
 * @param root0
 * @param root0.onSelect
 * @param root0.children
 * @returns {ReactElement}  page
 */
export function PieceFinder({
  onSelect,
  children,
}: {
  onSelect: (i: LibrarianPiece) => void;
  children: ReactNode;
}) {
  const [pieceAnchorEl, setPieceAnchorEl] = useState<
    (EventTarget & HTMLDivElement) | null
  >(null);
  const [title, setTitle] = useState("");
  const [composer, setComposer] = useState("");
  const genFilters = (name) => {
    const filters = [];

    if (composer) {
      filters.push({
        name: "pieces.composer",
        comparison: "like",
        value: composer.toLocaleLowerCase(),
      });
    }
    if (title) {
      filters.push({
        name,
        comparison: "like",
        value: title.toLocaleLowerCase(),
      });
    }

    return filters;
  };

  const { librarianPieces } = useLibrarianPieces(
    {
      filters: JSON.stringify(genFilters("pieces.title")),
      limit: 30,
    },
    { skip: `${title}${composer}`.length < 3 }
  );

  const onClose = () => {
    setPieceAnchorEl(null);
    setTitle("");
    setComposer("");
  };

  return (
    <>
      <Box onClick={(e) => setPieceAnchorEl(e.currentTarget)}>{children}</Box>
      <Popover
        onClose={onClose}
        anchorEl={pieceAnchorEl}
        open={Boolean(pieceAnchorEl)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box
          sx={{
            width: 500,
            height: 700,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            p: 1,
          }}
        >
          <Input
            startDecorator="Work"
            value={title}
            autoFocus
            onChange={(e) => setTitle(e.target.value)}
          />
          <Input
            startDecorator="Composer"
            value={composer}
            onChange={(e) => setComposer(e.target.value)}
          />
          {composer.length === 0 &&
          title.length === 0 &&
          librarianPieces.length === 0 ? (
            <Box
              sx={{
                flexGrow: 1,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                textAlign: "center",
              }}
            >
              <Box>
                <i
                  style={{ fontSize: 24 }}
                  className="fa-solid fa-magnifying-glass"
                ></i>
                <Typography>Search for a Piece by title or composer</Typography>
              </Box>
            </Box>
          ) : (
            []
          )}
          <List sx={{ flexGrow: 1, overflowY: "scroll" }}>
            {librarianPieces.map((p) => {
              return (
                <ListItemButton
                  key={p.id}
                  onClick={() => {
                    onSelect(p);
                    onClose();
                  }}
                >
                  <ListItemContent>
                    <Typography sx={{ fontWeight: 600 }} level="body2">
                      {p.title}
                    </Typography>
                    <Typography sx={{ opacity: 0.6 }} level="body4">
                      {p.composer}
                    </Typography>
                  </ListItemContent>
                  <ListItemDecorator>
                    <Button
                      onClick={() => window.open(p.link, "_blank")}
                      variant="plain"
                      endDecorator={
                        <i className="fa-solid fa-arrow-up-right"></i>
                      }
                      size="sm"
                    >
                      IMSLP
                    </Button>
                  </ListItemDecorator>
                </ListItemButton>
              );
            })}
          </List>
        </Box>
      </Popover>
    </>
  );
}
